import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { BaseButton } from 'components/BaseButton';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
    },
  },
  titleGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    minWidth: 0,
  },
  title: {
    color: theme.palette.primary.darker,
  },
  count: {
    color: theme.palette.text.secondary,
  },
  addButton: {
    alignSelf: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '@media (hover: none) and (pointer: coarse)': {
      '& .MuiButton-root': {
        minHeight: theme.spacing(5.5),
      },
    },
  },
}));

interface PartyHeaderProps {
  setOpenAddModal: React.Dispatch<React.SetStateAction<boolean>>;
  partiesCount?: number;
}

const PartyHeader: FC<PartyHeaderProps> = ({ setOpenAddModal, partiesCount }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const countLabel =
    partiesCount === 1
      ? t('parties:one-party')
      : t('parties:parties-count', { count: partiesCount ?? 0 });

  return (
    <Box className={classes.container}>
      <Box className={classes.titleGroup}>
        <Typography variant="h5" component="h1" className={classes.title}>
          {t('parties:parties')}
        </Typography>
        {typeof partiesCount === 'number' && (
          <Typography variant="body2" className={classes.count}>
            {countLabel}
          </Typography>
        )}
      </Box>
      <Box className={classes.addButton}>
        <BaseButton
          buttonVariant="contained"
          buttonColor="secondary"
          icon="plus"
          text={t('parties:add-party')}
          onClick={() => setOpenAddModal(true)}
          customStyle={{ minHeight: 40 }}
        />
      </Box>
    </Box>
  );
};

export default PartyHeader;
